var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        width: "900px",
        title: _vm.title,
        visible: _vm.visible,
        "append-to-body": "",
        "custom-class": "dialog-body",
        "show-close": false,
        "close-on-click-modal": false,
        "press-escape": false,
        top: "10vh",
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "ss-material-box-header",
          attrs: { slot: "title" },
          slot: "title",
        },
        [
          _c("div", [_vm._v(_vm._s(_vm.title))]),
          _c("i", {
            staticClass: "el-icon-close close",
            on: {
              click: function ($event) {
                _vm.visible = false
              },
            },
          }),
        ]
      ),
      _c("div", { style: { width: "900px", height: "500px" } }, [
        _c("div", { staticClass: "choose_resource" }, [
          _c(
            "div",
            [
              _c("span", { staticClass: "m-r-10" }, [_vm._v("激活链接: ")]),
              _c("el-input", {
                staticClass: "m-r-10",
                staticStyle: { width: "600px", "max-width": "100%" },
                attrs: { placeholder: "请输入", disabled: "" },
                model: {
                  value: _vm.src,
                  callback: function ($$v) {
                    _vm.src = typeof $$v === "string" ? $$v.trim() : $$v
                  },
                  expression: "src",
                },
              }),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "clipboard",
                      rawName: "v-clipboard:copy",
                      value: _vm.src,
                      expression: "src",
                      arg: "copy",
                    },
                    {
                      name: "clipboard",
                      rawName: "v-clipboard:success",
                      value: _vm.clipboardSuccess,
                      expression: "clipboardSuccess",
                      arg: "success",
                    },
                  ],
                  attrs: { type: "primary", icon: "el-icon-document" },
                },
                [_vm._v(" 复制 ")]
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "m-t-20 fl" },
            [
              _c("span", { staticClass: "m-r-10" }, [_vm._v("二维码: ")]),
              _c("AppQrcode", { attrs: { src: _vm.src } }),
            ],
            1
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }